import axios from 'axios'

import store from '@/store'

export default {
  getItemDetail (payload) {
    let params = `${payload.path}?id=${payload.id}`
    return axios.get(params, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      }
    })
      .then(response => {
        if (response) {
          return response.data
        } else {
          throw new Error('apiCommons: "response" invalido')
        }
      })
      .catch(error => {
        return error
      })
  },
  updateItemDetail (path, data) {
    return axios.post(path, data, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      }
    })
      .then(response => {
        if (response) {
          return response.data
        } else {
          throw new Error('apiCommons: "response" invalido')
        }
      })
      .catch(error => {
        throw error
      })
  },
  getItems (payload) {
    let params = `${payload.path}?offset=${payload.offset}&limit=${payload.limit}`
    if (payload.term) {
      params += `&term=${payload.term}`
    }
    if (payload.order) {
      params += `&order=${payload.order}`
    }
    if (payload.orderBy) {
      params += `&order_by=${payload.orderBy}`
    }
    if (payload.dateFrom) {
      params += `&date_from=${payload.dateFrom}`
    }
    if (payload.dateUpTo) {
      params += `&date_up_to=${payload.dateUpTo}`
    }
    if (payload.searchOnFields) {
      payload.searchOnFields.forEach(element => {
        params += `&search_on_fields=${element}`
      })
    }
    if (payload.aggregates) {
      payload.aggregates.forEach((element) => {
        let key = Object.keys(element)
        params += `&${key}=${element[key]}`
      })
    }
    return axios.get(params, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      }
    })
      .then(response => response.data)
      .catch(error => {
        return error
      })
  }
}
